module.exports = __webpack_public_path__ + "img/Image - Header 5(4).68a16330.png";